import { BrowserRouter, Routes, Route, } from "react-router";
import { lazy, Suspense, createElement } from "react";

import Preloader from './preloader';
import BottomBar from './bottomBar';

const Home = lazy(() => import('../screens/home'));

const routes = [
  {
    path: '/',
    element: Home,
  }
];

function App() {
  return (
    <div id="application-layout">
      <BrowserRouter>
        <div id="app-main">
          <Suspense fallback={<Preloader/>}>
            <Routes>
              {routes.map((route, index) => (
                <Route path={route.path} element={createElement(route.element)} key={`rt-${index}`} />
              ))}
            </Routes>
          </Suspense>
        </div>
        <BottomBar/>
      </BrowserRouter>
    </div>
  );
}

export default App;
